module.exports = __webpack_public_path__ + "media/bleep.f0650ddd.wav";